import React from 'react';
import Modal from '../Modal.jsx';
import HorairesManager from '../HorairesManager.jsx';

export default function CommercantHorairesSubModal({
  isOpen,
  onClose,
  commercant,
  onSave,
  saving = false,
}) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Horaires de la boutique"
      maxWidth="max-w-4xl"
      nested
    >
      <p className="mb-4 text-sm text-gray-600">
        Ces horaires s&apos;appliquent à toute la boutique. Les activités sans plage personnalisée
        proposent des créneaux automatiquement pendant ces plages.
      </p>
      <HorairesManager
        horaires={commercant?.horaires ?? []}
        onSave={onSave}
        loading={saving}
        isItinerant={Boolean(commercant?.magasinItinerant)}
        startInEditMode
      />
    </Modal>
  );
}
